import BaseNavigationView from 'base/navigator/BaseNavigationView';

class M_404 extends BaseNavigationView {
  constructor(props) {
    super(props);
    window.location.reload();
  }

  render() {
    return null;
  }
}
export default M_404;
